import React from 'react';
import PropTypes from 'prop-types';
import {Grid, Button} from 'semantic-ui-react';
import DynamicForm from './dynamicForm';
import _ from 'lodash';

const DynamicFormContainer = class DynamicFormContainer extends React.Component {
  static propTypes = {
    /** A unique id for the form */
    id: PropTypes.string.isRequired,

    /** The URI that hosts configurations for the form */
    configResourceURI: PropTypes.string.isRequired,

    /** The URI that contains/accepts form backing data */
    dataResourceURI: PropTypes.string.isRequired,
  };

  constructor(props) {
    super(props);

    this.formId = props.id;
    this.configResourceURI = props.configResourceURI;
    this.dataResourceURI = props.dataResourceURI;
    this.showSaveButton = props.showSaveButton;

    this.state = {
      model: props.model,
      config: props.config,
    };
  }

  UNSAFE_componentWillMount() {
    this.getFormConfig();
    this.getModel();
  }

  doRESTOp = (methodType, body, uri, stateVars) => {
    let params = {
      method: methodType,
    };
    if (methodType === 'post') {
      params.body = JSON.stringify(body);
    }
    fetch(uri, params)
      .then((response) => response.json())
      .then((response) =>
        _.forEach(stateVars, (stateVar) => this.setState({[stateVar]: response}))
      );
  };

  getFormConfig = () => this.doRESTOp('get', null, this.configResourceURI, ['config']);

  getModel = () =>
    this.doRESTOp('get', null, this.dataResourceURI, ['origModel', 'model']);

  isDirty = () => this.state.origModel !== this.state.model;

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.model !== this.state.model) {
      this.setState({model: nextProps.model});
    }
  }

  saveModel = () => {
    this.isDirty() &&
      this.doRESTOp('post', this.state.model, this.dataResourceURI, [
        'origModel',
        'model',
      ]);
  };

  updateModel = (modelKey, value) => {
    const model = Object.assign({}, this.state.model);
    model[modelKey] = value;

    let postUpdateModel = () => {
      return true;
    };
    const parentPostUpdateModel = this.props.postUpdateModel;
    if (parentPostUpdateModel) {
      postUpdateModel = () => {
        return parentPostUpdateModel(this.state.model);
      };
    }

    if (this.props.preUpdateModel) {
      if (this.props.preUpdateModel(model)) {
        this.setState({model}, postUpdateModel);
        return true;
      }
    } else {
      this.setState({model}, postUpdateModel);
      return true;
    }
  };

  render() {
    return (
      <Grid>
        <Grid.Row>
          <Grid.Column>
            <DynamicForm
              id={this.formId}
              config={this.props.config}
              model={this.state.model}
              updateModel={this.updateModel}
            />
          </Grid.Column>
        </Grid.Row>
        {this.showSaveButton === true && (
          <Grid.Row>
            <Grid.Column textAlign="left">
              <Button onClick={() => this.saveModel()} primary>
                Save
              </Button>
            </Grid.Column>
          </Grid.Row>
        )}
      </Grid>
    );
  }
};

export default DynamicFormContainer;
